import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { TemplateRoleContact } from '../../../../types';
import { DocumentParams } from '../../../documents/types/DocumentParams';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../../constants/signatureBasePath';
import { listSignatureTemplateRoleContacts } from '../../requests/listSignatureTemplateRoleContacts';

export const useSignatureTemplateRoleContacts = (
  roleId: string,
  documentParams: DocumentParams<'definition'>,
  params?: RequestConfig['params'],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, ...rest } = useQuery<
    NonPaginatedResponse<TemplateRoleContact[]> | undefined
  >({
    queryKey: [
      SIGNATURE_BASE_PATH,
      'template-role-contacts',
      roleId,
      documentParams,
      params,
    ],
    queryFn: () =>
      listSignatureTemplateRoleContacts(
        constructGet,
        roleId,
        documentParams,
        params,
      ),
    staleTime: 10000,
    ...options,
  });

  return { contacts: data?.data, ...rest };
};
